module.exports = __webpack_public_path__ + "static/media/pl.1f4f8ec3.svg";